import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { SheetFolderListStateService } from '@modules/sheets/services/sheet-folder-list-state.service';
import { SheetFoldersService } from '@modules/sheets/services/sheet-folders.service';
import { SheetFolder } from '@modules/sheets/types/sheet-folder';
import { SheetFoldersFilters } from '@modules/sheets/types/sheet-folders-filters';
import { SheetFoldersListState } from '@modules/sheets/types/sheet-folders-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-sheet-folders-section',
  templateUrl: './sheet-folders-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...SheetFolderListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeSheetFoldersSectionComponent
  extends KnowledgeStitchSectionComponent<SheetFolder, SheetFoldersFilters>
  implements OnInit
{
  protected readonly listStateService = inject(SheetFolderListStateService, { self: true });
  protected readonly stitchService = inject(SheetFoldersService);

  public override ngOnInit(): void {
    this.state = new SheetFoldersFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: SheetFoldersListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new SheetFoldersFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
